/* --------------------------------------------
 *
 * Return a truthy value if is zero
 *
 * --------------------------------------------
 */
export default function canBeZero (val) {
	if (val === 0) {
		return true;
	}
	return val;
}
